export default "__VITE_ASSET__CjqHMn3u__"